export function main() {
  // if ($(window).width() > 1250) {
  //   $('.nav li').on('mouseenter', function() {
  //     $('.sub-nav').hide();
  //     const sub = $(this).data('sub')
  //     $(`.${sub}`).show();
  //   });
  //   $('.menu-section__box').on('mouseleave', ()=> {
  //     $('.sub-nav').hide();
  //   });
  // }
  $(document).on('click', ".town__active", function(e) {
    $(this).toggleClass("open");
    $('.town__list').toggle();
  });

  $(document).on('click', (e) => {
    if (!$(e.target).closest('.town, .town__list').length) {
      $('.town__list').css('display', 'none');
      $('.town__active').removeClass('open');
    }
    e.stopPropagation();
  });

  $(document).on('click', ".book", function(e) {
    $('.popup-order').toggleClass('active');
    e.preventDefault();
  });

  $(document).on('click', ".popup__close, .popup__overlay", function() {
    $('.popup').removeClass('active');
  });

  $(document).on('click', ".menu-opener", function() {
    $(this).toggleClass('active');
    $('.nav').toggleClass('active');
  });

}



// WEBPACK FOOTER //
// app/scripts/components/main.js